import { render, staticRenderFns } from "./DashboardNewPC.vue?vue&type=template&id=7e2212a8&scoped=true"
import script from "./DashboardNewPC.vue?vue&type=script&lang=js"
export * from "./DashboardNewPC.vue?vue&type=script&lang=js"
import style0 from "./DashboardNewPC.vue?vue&type=style&index=0&id=7e2212a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2212a8",
  null
  
)

export default component.exports